
import { useRef } from 'react'
import { useDetailsPopover } from '@/lib/use-details-popover'

/**
 * A `<details>` popover that behaves like one.
 *
 * The rail's workspace switcher and account menu were bare `<details>`: Escape
 * did nothing, clicking the page behind left them open, two could be open at
 * once, and a screen reader was never told the control opens something. Native
 * `<details>` still does the work; this adds what it does not give you.
 */
export function Popover({
  summary,
  summaryClass,
  className,
  children,
}: {
  /** The clickable control. Gets aria-haspopup and the summary styling. */
  summary: React.ReactNode
  summaryClass?: string
  /** Classes for the popover panel itself. */
  className?: string
  children: React.ReactNode
}) {
  const ref = useRef<HTMLDetailsElement>(null)
  useDetailsPopover(ref)

  return (
    <details ref={ref} className="relative">
      <summary className={summaryClass} aria-haspopup="true">
        {summary}
      </summary>
      <div className={className}>{children}</div>
    </details>
  )
}
